import React from 'react'

const AlertGroupHeader = (props) => {
    return (
        <div className="list-view-group-header text-uppercase">
            {props.title}
        </div>
    )
}

export default AlertGroupHeader
